
const Index = r => require.ensure([], () => r(require('./Index')), 'aojiEnglish')
const scheduleCard = r => require.ensure([], () => r(require('./scheduleCard')), 'scheduleCard')
const bindList = r => require.ensure([], () => r(require('./bindList')), 'bindList')
const scheduleDetail = r => require.ensure([], () => r(require('./scheduleDetail')), 'scheduleDetail')
const bindContract = r => require.ensure([], () => r(require('./bindContract')), 'bindContract')
const contractDetail = r => require.ensure([], () => r(require('./contractDetail')), 'contractDetail')

export default {
  path: '/aojiEnglish',
  component: Index,
  children: [
    {
      meta: {
        title: '课程表'
      },
      path: 'schedule-card',
      name: 'scheduleCard',
      component: scheduleCard
    },
    {
      meta: {
        title: '绑定列表'
      },
      path: 'bind-list',
      name: 'bindList',
      component: bindList
    },
    {
      meta: {
        title: '课程详情页'
      },
      path: 'schedule-detail',
      name: 'scheduleDetail',
      component: scheduleDetail
    },
    {
      meta: {
        title: '绑定合同'
      },
      path: 'bind-contract',
      name: 'bindContract',
      component: bindContract
    },
    {
      meta: {
        title: '我的资料'
      },
      path: 'contract-detail',
      name: 'contractDetail',
      component: contractDetail
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/aojiEnglish/router.js